import React, { useMemo } from 'react'
// Libs
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Layouts
import { DefaultLayout, AuthLayout } from '../pages/_layouts'

export const RouteWrapper = ({ component: Component, isPrivate, ...rest }) => {
  const { token } = useSelector(state => state.auth)

  const LayoutMemo = useMemo(() => {
    const signed = token ? true : false

    if (!signed && isPrivate) {
      return <Redirect to="/" />
    }

    if (signed && !isPrivate) {
      return <Redirect to="/dashboard" />
    }

    const Layout = signed ? DefaultLayout : AuthLayout

    return (
      <Route
        {...rest}
        render={props => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  }, [rest, token, isPrivate])

  return LayoutMemo
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool
}

RouteWrapper.defaultProps = {
  isPrivate: false
}
